<template>
  <div
    class="buscador row input-group input-group-lg col-lg-12 mx-auto px-0 my-4"
    role="group"
    aria-label="first group"
  >
    <div class="col row buscador btn-group px-0 ml-0 mr-lg-3">
      <div class="col-12 row px-0 ml-0">
        <div class="buscador btn-group col-lg-3 mb-3 mb-md-0 px-0">
          <div class="w-100 px-0 mr-lg-3">
            <b-form-select
              v-model="busqueda.region"
              class="custom-select multiple region rounded-0"
              @change="cambiarRegion"
            >
              <option disabled value="null">Región</option>
              <option
                v-for="r in regiones"
                :key="r.idRegion"
                :value="r.valorBusqueda"
              >
                {{ limpiarNombreRegion(r.nombreRegion) }}
              </option>
              <option value="TODAS">Todas</option>
            </b-form-select>
          </div>
        </div>
        <div class="buscador btn-group col-lg mb-3 mb-md-0 px-0">
          <div class="w-100 px-0 mr-lg-3">
            <b-form-select
              v-model="busqueda.institucion"
              class="custom-select form-control-lg multiple instt"
              @change="cambiarInstitucion"
            >
              <option disabled value="null">Institución</option>
              <option
                v-for="uni in universidades"
                :key="uni.index"
                :value="uni"
              >
                {{ uni }}
              </option>
              <option value="TODAS">Todas</option>
            </b-form-select>
          </div>
        </div>
        <div class="col-12 col-lg-3 px-0 mb-lg-0">
          <div class="w-100 px-0">
            <b-form-select
              v-model="busqueda.jornada"
              class="custom-select multiple gratuidad"
              @change="cambiarJornada"
            >
              <option disabled value="null">Modalidad</option>
              <option
                v-for="opcion in optionsJornada"
                :key="opcion.index"
                :value="opcion.valor"
              >
                {{ opcion.texto }}
              </option>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="col-12 row px-0 ml-0 mb-3 mt-3 mb-lg-0">
        <Autocompletado
          :nombreCarrera="busqueda.carrera"
          :matches="itemsAutocomplete"
          inputClass="w-100 form-control form-control-lg rounded-0 mb-3 mb-lg-0 py-1"
          textoPlaceHolder="Nombre Carrera"
          @selected="buscarNombreCarrera"
          @asignarTextoIncompleto="asignarTextoIncompleto"
          @change="buscarAutocompletado"
          @busquedaExacta="busquedaExacta"
        />
      </div>
    </div>
    <div class="input-lg pr-0 flex-shrink-1 d-none d-lg-block">
      <button
        class="btn btn-blue rounded-0 px-3 pl-3 h-100"
        style="height: 2.625rem"
        type="button"
        id="inputGroupFileAddon"
        v-b-tooltip.hover
        title="Buscar"
        @click="validarFormulario"
      >
        <FontAwesomeIcon icon="search" class="mt-1" />
      </button>
    </div>
    <div class="col-12 input-lg align-self-center px-0 d-block d-lg-none">
      <button
        class="btn btn-blue w-100 rounded-0"
        type="button"
        id="inputGroupFileAddon"
        v-b-tooltip.hover
        title="Buscar"
        @click="validarFormulario"
      >
        <FontAwesomeIcon icon="search" class="mt-1" />
      </button>
    </div>
  </div>
</template>

<script>
import ApiRegiones from "@/services/ApiRegiones";
import Busqueda from "@/utils/Busqueda.js";
import MixinRegiones from "@/mixins/regiones.js";
import MixinTags from "@/mixins/tags.js";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSearch, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Autocompletado from "@/components/generales/Autocompletado";
import ApiBuscador from "@/services/ApiBuscador";
import { validacion } from "@/utils/ValidacionGenerica";
library.add(faSearch, faPlus);
export default {
  name: "FormBusqueda",
  mixins: [MixinRegiones, MixinTags],
  components: {
    FontAwesomeIcon,
    Autocompletado
  },
  data() {
    return {
      busqueda: {
        region: null,
        institucion: null,
        jornada: null,
        carrera: "",
        busquedaExacta: null
      },
      itemsAutocomplete: [],
      listaCampos: ["REGION", "INSTITUCION", "JORNADA", "NOMBRE_CARRERA"],
      listadoInstituciones: []
    };
  },
  async created() {
    this.listadoInstituciones = await this.cargarInstituciones();
    this.reiniciarValores();
  },
  watch: {
    getBusquedasAplicadas(lista) {
      if (lista.length >= 1) {
        let filtros = lista.map(f => f.tipo);
        this.listaCampos.forEach(c => {
          if (!filtros.includes(c)) {
            switch (c) {
              case "REGION":
                this.busqueda.region = null;
                break;
              case "INSTITUCION":
                this.busqueda.institucion = null;
                break;
              case "JORNADA":
                this.busqueda.jornada = null;
                break;
              case "NOMBRE_CARRERA":
                this.busqueda.carrera = "";
                break;
              default:
                break;
            }
          }
        });
      } else {
        this.limpiarCampos();
      }
      this.buscarCarrera();
      }
  },
  computed: {
    optionsJornada() {
      return Busqueda.criteriosJornada();
    },
    universidades() {
      if (this.listadoInstituciones.length >= 1) {
        let listado = this.listadoInstituciones;
         if (this.busqueda.region !== null && this.busqueda.region !== "TODAS") {
        listado = listado.filter(c => {
          return c.region === this.busqueda.region;
        });
      }
        listado = listado.map(u => u.nombreInstitucion);
        listado = [...new Set(listado)];
        listado.sort((a, b) => a.localeCompare(b));
        return listado;
      } else {
        return [];
      }
    }
  },
  methods: {
    async buscarAutocompletado(valor) {
      let res = await ApiBuscador.getNombresCarrerasUniversitariasAutocompletado(
        valor
      );
      if (res !== "") {
        this.itemsAutocomplete = res;
      } else {
        this.itemsAutocomplete = [];
      }
    },
    async cargarInstituciones() {
      let parametros = {
        region: null
        /*this.busqueda.region && this.busqueda.region !== "TODAS"
            ? this.busqueda.region
            : null,*/
      };
      let instituciones = await ApiBuscador.getListadoUniversidadesPorRegion(
        parametros
      );
      if (instituciones) {
        this.instituciones = instituciones;
      }
      return instituciones;
    },
    buscarCarrera() {
      this.$emit("buscarCarrera", this.busqueda);
      this.busqueda.busquedaExacta = null;
    },
    busquedaExacta(val) {
      this.busqueda.busquedaExacta = val;
    },
    validarFormulario() {
      if (this.busqueda.carrera !== "") {
        this.buscarNombreCarrera(this.busqueda.carrera);
      } else {
        this.buscarCarrera();
      }
    },
    buscarNombreCarrera(val) {
      let filtro = {
        valor: val,
        texto: val
      };
      this.busqueda.carrera = val;
      this.guardarBusquedaTags(filtro, "NOMBRE_CARRERA");
    },
    cambiarRegion(val) {
      let filtro;
      if (val !== "TODAS") {
        let valor = this.regiones.find(i => i.valorBusqueda === val);
        filtro = {
          valor: valor.valorBusqueda,
          texto: this.limpiarNombreRegion(valor.nombreRegion)
        };
      } else {
        filtro = {
          valor: val,
          texto: "REGIÓN: Todas"
        };
      }
      this.limpiarFiltroInstitucion();
      this.guardarBusquedaTags(filtro, "REGION");
    },
    limpiarFiltroInstitucion() {
      this.busqueda.institucion = null;
      let filtrosAplicados = [...this.getBusquedasAplicadas];
      let indiceFiltro = filtrosAplicados.findIndex(
        f => f.tipo === "INSTITUCION"
      );
      if (indiceFiltro !== -1) {
        filtrosAplicados.splice(indiceFiltro, 1);
      }
      this.setBusqueda(filtrosAplicados);
    },
    cambiarJornada(val) {
      let filtro = {
        valor: val,
        texto: val.replace(/(_)/gi, " ")
      };
      if (filtro.valor === "TODAS") {
        filtro.texto = "MODALIDAD: Todas";
      } else if (filtro.valor === "DIURNO") {
        filtro.texto = "PRESENCIAL DIURNA";
      } else if (filtro.valor === "VESPERTINO") {
        filtro.texto = "PRESENCIAL VESPERTINA";
      }
      this.guardarBusquedaTags(filtro, "JORNADA");
    },
    cambiarInstitucion(val) {
      let filtro = {
        valor: val,
        texto: val
      };
      if (filtro.valor === "TODAS") {
        filtro.texto = "Institución: Todas";
      }
      this.guardarBusquedaTags(filtro, "INSTITUCION");
    },
    asignarTextoIncompleto(val) {
      this.busqueda.carrera = val;
    },
    reiniciarValores() {
      let busquedasAplicadas = this.getBusquedasAplicadas;
      if (busquedasAplicadas.length >= 1) {
        busquedasAplicadas.forEach(f => {
          switch (f.tipo) {
            case "REGION":
              this.busqueda.region = f.filtro;
              break;
            case "INSTITUCION":
              this.busqueda.institucion = f.filtro;
              break;
            case "JORNADA":
              this.busqueda.jornada = f.filtro;
              break;
            case "NOMBRE_CARRERA":
              this.busqueda.carrera = f.filtro;
              break;
            default:
              break;
          }
        });
      }
    },
    limpiarCampos() {
      this.busqueda.region = null;
      this.busqueda.institucion = null;
      this.busqueda.jornada = null;
      this.busqueda.carrera = "";
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/buscadorCU/FormBusqueda.vue